// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, Td, Tr, useDisclosure } from "@chakra-ui/react"
import { Dash, Icon, IconButton, Section, Table, Tag } from "components"

// Config
import { Moment } from "config"

// Hooks
import { useAttachments } from "hooks"

// Screens
import { File } from 'screens'

export default function Files({ data, model, title, options }){

    const attachments = useAttachments(model, data?.id)
    const upload = useDisclosure()
    const [ trash, setTrash ] = useState(false)

    const columns = [{ children: '' }, { children: 'Arquivo' }, { children: 'Descrição' }, { children: 'Tamanho', isNumeric: true }, { children: 'Data', isNumeric: true }, { children: '', isNumeric: true }]

    return(
    <>
    <Section title={title}>
        <ButtonGroup size="xs" isDisabled={attachments.isFetching}>
            <Button children="Enviar arquivo" leftIcon={<Icon name="upload" />} onClick={upload.onOpen} />
            <IconButton label="Atualizar" icon="refresh" isLoading={attachments.isFetching} onClick={attachments.refetch} />
        </ButtonGroup>
    </Section>

    <Table columns={columns} mt={6}>
        { attachments.data?.data?.map(item => <FileItem key={item.id} data={item} onTrash={setTrash} />) }
    </Table>

    {/* Screens */}
    <File.Upload {...upload} options={options} onSuccess={attachments.refetch} />
    <File.Trash isOpen={!!trash} onClose={() => setTrash(false)} data={trash} onSuccess={attachments.refetch} />
    </>
    )
}

const FileItem = ({ data, onTrash = () => {} }) => {
    return(
    <Tr>
        <Td isNumeric><Icon name={data.metadata?.extension} width={5} height={5} /></Td>
        <Td fontSize="xs" children={data.filename} />
        <Td><Dash children={data.label} /></Td>
        <Td isNumeric><Tag size="sm" children={data.size} /></Td>
        <Td isNumeric children={Moment(data.created_at).calendar()} />
        <Td isNumeric>
            <ButtonGroup size="xs">
                <IconButton label="Download" icon="download" onClick={() => window.open(data.download_url)} />
                <IconButton label="Excluir" icon="trash" colorScheme="red" variant="outline" onClick={() => onTrash(data)} />
            </ButtonGroup>
        </Td>
    </Tr>
    )
}